import { GeoJsonDataType } from '../../../../../features/map/layers/PointDataLayers';
import { Variety } from './variety';

export const MAX_PLANT_SPACING = 30; // the highest value I found in our current data was about 12 so this should be safe
export const MAX_ROW_SPACING = 30;

export type Block = {
  id: string;
  name: string;
  ranchID: string;
  acres?: number | null;
  fromDate?: string | null;
  thruDate?: string | null;
  plantSpacing?: number | null;
  rowSpacing?: number | null;
  trellisSystem?: string | null;
  pruningMethod?: string | null;
  varietyID: string;
  /**
   * @deprecated Use `varietyID` + useVariety if you want access to the Variety (which now also stores the crop type) object instead.
   * If you need the stages of a variety, consider utilizing the `useStages` hook.
   */
  variety: Variety;
  rootStock?: string | null;
  geoPolygon: GeoJsonDataType;
  geoOrientation: GeoJsonDataType;
};
